import { render, staticRenderFns } from "./border-view.vue?vue&type=template&id=b95fdcaa&scoped=true&"
import script from "./border-view.vue?vue&type=script&lang=js&"
export * from "./border-view.vue?vue&type=script&lang=js&"
import style0 from "./border-view.vue?vue&type=style&index=0&id=b95fdcaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95fdcaa",
  null
  
)

export default component.exports